import { Skeleton } from '../ui/Skeleton';
import pt from '../../locales/pt';

function GroupSkeleton() {
  return (
    <div className="flex flex-col gap-space-3 rounded-ds-lg border border-border bg-card p-space-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-6 rounded-ds-sm" />
          <Skeleton className="h-3 w-24" />
        </div>
        <Skeleton className="h-3.5 w-16" />
      </div>
      <div className="h-px bg-border" aria-hidden />
      <div className="flex flex-col gap-space-3">
        {[0, 1].map((i) => (
          <div key={i} className="flex items-center gap-space-3 py-1">
            <Skeleton className="h-8 w-8 shrink-0 rounded-ds-md" />
            <div className="flex flex-1 flex-col gap-1.5">
              <Skeleton className="h-3 w-3/5" />
              <Skeleton className="h-2.5 w-2/5" />
            </div>
            <Skeleton className="h-3.5 w-16" />
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * `.pen` → skeleton dedicado de Ativos ("skeleton · resumo" +
 * "skeleton · grupo" × 2): cartão-resumo (`ds/skeleton/metric-card`) seguido
 * de dois cartões de grupo com cabeçalho + linhas (`ds/skeleton/list-row`).
 * Mais próximo do layout real desta página do que o `SectionSkeleton`
 * genérico.
 */
export function AccountsLoadingSkeleton() {
  return (
    <div className="flex flex-col gap-space-4" aria-busy="true" aria-label={pt.common.loading}>
      <div className="flex flex-col gap-space-4 rounded-ds-xl border border-border bg-card p-space-5">
        <div className="flex items-center justify-between">
          <Skeleton className="h-3 w-32" />
          <Skeleton className="h-5 w-16 rounded-ds-full" />
        </div>
        <Skeleton className="h-9 w-40" />
        <Skeleton className="h-2 w-full rounded-ds-full" />
        <Skeleton className="h-32 w-full rounded-ds-lg" />
      </div>
      <div className="flex flex-col gap-space-3">
        <GroupSkeleton />
        <GroupSkeleton />
      </div>
    </div>
  );
}
